import { useFlipperFlag } from './useFlipperFlag'
import { useIsVirtualMarketer } from './useIsVirtualMarketer'
import useResponsiveDesign from './useResponsiveDesign'

export const useIsSystemRedesign = () => {
  const { isMobile } = useResponsiveDesign()
  const isVirtualMarketer = useIsVirtualMarketer()
  const isSystemRedesign = useFlipperFlag('system_redesign')

  return isVirtualMarketer && isSystemRedesign && !isMobile
}
